module.exports = __webpack_public_path__ + "img/hero-banner-visual.a53cdde.png";